<div class="filter-drawer-header">
  <h3 class="filter-drawer-header-title">Filters</h3>
  <button class="close-drawer-button" data-cy="close-drawer-button" mat-button
          aria-label="Close Filter Drawer" (click)="filterDrawerService.toggle()">
    <mat-icon>close</mat-icon>
  </button>
</div>
